 module.exports = {
  env: 'prod',
  microfrontend: {
    '@mfe/ReportLibrary_local': 'report_library@http://localhost:9010/remoteEntry.js',
    '@mfe/ReportLibrary_dev': 'report_library@https://report-library-service.westus.dev.k8s.underpaid.com/remoteEntry.js',
    '@mfe/ReportLibrary_prestaging': 'report_library@https://report-library-service.westus.prestaging.k8s.underpaid.com/remoteEntry.js',
    '@mfe/ReportLibrary_prod': 'report_library@https://report-library-service.westus.prod.k8s.payscale.com/remoteEntry.js',
  }
}
